// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Crosshair(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Crosshair" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M14.5 9.5H9.5V14.5H14.5V9.5Z", fill: "currentColor" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.75 2H11.25V6H6V11.25H2V12.75H6V18H11.25V22H12.75V18H18V12.75H22V11.25H18V6H12.75V2ZM7.5 7.5H16.5V16.5H7.5V7.5Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Crosshair.js.map